import { createSelector } from 'reselect'
import API from '../../../utils/http/api'
import fixtures from '../../../fixtures'

// Action Types
const REQUEST = 'steppingblocks/savedJobs/REQUEST'
const SUCCESS = 'steppingblocks/savedJobs/SUCCESS'
const FAILURE = 'steppingblocks/savedJob/FAILURE'
const DELETE_SAVED_SUCCESS = 'steppingblocks/savedJob/DELETE_SAVED_SUCCESS'
const DELETE_SAVED_JOB = 'steppingblocks/savedJob/DELETE_SAVED_JOB'

// Reducer
const initialState = {
  error: null,
  requestStarted: false,
  requestEnded: false,
  results: [],
  pagination: fixtures.pagination,
  deletingSavedJob: false,
}

export default (_state = initialState, action) => {
  const { type, payload } = action
  switch (type) {
    case REQUEST:
      return {
        ..._state,
        error: null,
        requestStarted: true,
        requestEnded: false,
      }
    case SUCCESS:
      return {
        ..._state,
        requestEnded: true,
        results: payload.results,
        pagination: payload.pagination,
      }
    case DELETE_SAVED_SUCCESS:
      return {
        ..._state,
        requestEnded: true,
        results: _state.results.filter(item => item._id !== payload.id),
        deletingSavedJob: false,
      }
    case FAILURE:
      return {
        ..._state,
        requestEnded: true,
        error: payload.error,
      }
    case DELETE_SAVED_JOB:
      return {
        ..._state,
        deletingSavedJob: true,
      }
    default:
      return _state
  }
}

// Action Performers
export const performRetrieveSavedJobs = params => async dispatch => {
  dispatch({ type: REQUEST })
  try {
    const data = await API.get(`/jobs/saved/${params.user_id}`, {})
    dispatch({
      type: SUCCESS,
      payload: {
        results: data.saved_jobs,
        pagination: data.pagination,
      },
    })
    return data
  } catch (error) {
    dispatch({
      type: FAILURE,
      payload: { error: error.message },
    })
    return error
  }
}

export const performSaveJob = params => async dispatch => {
  dispatch({ type: REQUEST })
  const job_data = params

  try {
    const data = await API.post('/jobs/save', { job_data })
    dispatch({
      type: SUCCESS,
      payload: {
        results: [],
      },
    })
    return data
  } catch (error) {
    dispatch({
      type: FAILURE,
      payload: { error: error.message },
    })
    throw new Error(error)
  }
}

export const performDeleteSavedJob = params => async dispatch => {
  dispatch({ type: REQUEST })
  dispatch({ type: DELETE_SAVED_JOB })
  try {
    await API.del(`/jobs/save/${params.id}`)
    dispatch({
      type: DELETE_SAVED_SUCCESS,
      payload: {
        id: params.id,
      },
    })
  } catch (error) {
    dispatch({
      type: FAILURE,
      payload: { error: error.message },
    })
    throw new Error(error)
  }
}

// Selectors
const savedJobs = state => state.savedJobs

export const getSavedJobs = createSelector(savedJobs, data => data.results)



// WEBPACK FOOTER //
// ./src/routes/authenticated/JobSearch/savedJobsDuck.js